import { render, staticRenderFns } from "./codeTabMenu.vue?vue&type=template&id=b8467952&scoped=true&"
import script from "./codeTabMenu.vue?vue&type=script&lang=js&"
export * from "./codeTabMenu.vue?vue&type=script&lang=js&"
import style0 from "./codeTabMenu.vue?vue&type=style&index=0&id=b8467952&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8467952",
  null
  
)

export default component.exports